import { createIcon } from '../icon'
import TwitterIcon from '../svg/TwitterIcon'

export const TwitterIconDefault = createIcon(TwitterIcon)
